import axios from 'axios';
import { ApiConstant, CodeConstant } from '../../constants';
import { getAllUserProfileData } from '../../services/Dashboard';
import {pushLog2DV2LogServer} from "../../services/logging";
import jwt from "jsonwebtoken";

/**
 * This method should be removed once `mcq_use_apiv1` flag is rolled out to 100% users
 * @param {*} data The data that needs to be passed as request body
 * @returns The response provided by the API
 */
export const getAllMCQChallenges = (data = null) => {
  const body = {
    action: 'GET_MCQ_CHALLENGES',
    ...data
  };
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body);
  }
};

/**
 * This method provides the most recent version of API to fetch the list of MCQ Challenges
 * @param {*} data The data that needs to be passed as request body
 * @returns The response provided by the API
 */
export const getAllMCQChallenges_V1 = (data = null) => {
  const body = {
    ...data
  };
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}v1/challenge/mcq/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}v1/challenge/mcq/`, body);
  }
};

/**
 * This method provides the most recent version of API to fetch the list of MCQ Challenges
 * @param {*} data The data that needs to be passed as request body
 * @returns The response provided by the API
 */
export const getAllMCQChallenges_V2 = () => {
  const body = {};
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}v2/challenge/mcq/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}v2/challenge/mcq/`, body);
  }
};

export const getTagsMCQFilter = (data = null) => {
  const body = {
    action: 'GET_TAGS_MCQ_FILTER',
    ...data
  };
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body);
  }
};

export const getDeveloperRecommendedMCQ = () => {
  const body = {
    action: 'GET_DEVELOPER_RECOMMENDED_MCQ'
  };
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body);
  }
};

export const fetchWorkExpMCQInfo = (challenge_id) => {
  const body = {
    action: 'GET_WORK_EXP_MCQ_TIME_INFO',
    challenge_id: challenge_id
  };
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body);
  }
};

export const getMCQRole = () => {
  const body = {
    action: 'GET_MCQ_ROLE'
  };
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body);
  }
};

export const checkProfileStatus = () => {
  const body = {
    action: 'CHECK_PROFILE_COMPLETED_V2'
  };

  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body);
  }
};

export const updateMCQRole = (role_id) => {
  const body = {
    action: 'UPDATE_MCQ_ROLE',
    role_id
  };
  const token = localStorage.getItem('token');
  let header;

  if (token) {
    header = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
  } else {
    return axios.post(`${ApiConstant.BASE_URL}challenge/`, body);
  }
};

export const skillKeyToMCQ = async () => {
  let skillData = [];
  try {
    const response = await getAllMCQChallenges();
    const skills = await getDeveloperSkills();

    if (response.data.success) {
      if (response.data.result.length > 0) {
        skillData = await response.data.result.map(async (challenge) => {
          // Please make a note that `star_config` has been removed from the new MCQ List API /api/v1/challenge/mcq/
          if (!challenge.star_config) {
            challenge.skill = 0;
          } else {
            // Please make a note that `star_config` has been removed from the new MCQ List API /api/v1/challenge/mcq/
            const starConfig = challenge.star_config.split(',').map(config => config.toLowerCase());
            const availableSkill = checkSkillChallenge(starConfig, skills);
            // Please make a note that `admin_starred` has been removed from the new MCQ List API /api/v1/challenge/mcq/
            if (availableSkill || challenge.admin_starred === 1) {
              challenge.skill = 1;
            } else {
              challenge.skill = 0;
            }
          }
          return challenge;
        });
      }
    }
    return Promise.all(skillData).then(values => {
      return values;
    });
  } catch (e) {
    console.log(e);
    return skillData;
  }
};

const checkSkillChallenge = (starConfig, skills) => {
  let isContainSkill = false;
  try {
    // const skills = await getDeveloperSkills();
    skills.forEach((skill) => {
      if (skill.skill_level > 1 && starConfig.indexOf(skill.skill_name.toLowerCase()) !== -1) {
        isContainSkill = true;
      }
    });
    return isContainSkill;
  } catch (e) {
    console.log(e);
    return isContainSkill;
  }
};

const getDeveloperSkills = async () => {
  let developerSkill = [];
  const res = await getAllUserProfileData(null, null);
  if (res.data.code === CodeConstant.OK) {
    developerSkill = res.data.data.skills_info;
    return developerSkill;
  } else return developerSkill;
};

export const getUnattemptedSkillChallenge = async () => {
  let unAttemptedSkillChallenge = [];
  try {
    // Please make a note that `skillKeyToMCQ` uses `admin_starred` and the key `admin_starred` has been removed from the new MCQ List API /api/v1/challenge/mcq/
    const allChallenge = await skillKeyToMCQ();
    if (allChallenge.length > 0) {
      unAttemptedSkillChallenge = allChallenge.filter(challenge => (
        challenge.skill === 1
      ));
      return unAttemptedSkillChallenge;
    }
    return unAttemptedSkillChallenge;
  } catch (e) {
    console.log(e);
    return unAttemptedSkillChallenge;
  }
};

export const getShowinTIMCQ = async () => {
  let tiTabChallenge = [];
  try {
    const allChallenge = await getAllMCQChallenges();
    if (allChallenge.data.success && allChallenge.data.result.length > 0) {
      tiTabChallenge = allChallenge.data.result.filter(challenge => {
        const tagArray = challenge.tag_name ? challenge.tag_name.split(',').map(tag => tag.toLowerCase()) : [];
        const tiChallenge = tagArray.indexOf('show_in_ti_tab') !== -1;
        challenge.tags = challenge.tag_name;
        // Please make a note that `category_names` has been removed from the new MCQ List API /api/v1/challenge/mcq/
        challenge.tag_name = challenge.category_names;
        if (tiChallenge) return challenge;
      });
      return tiTabChallenge;
    }
    return tiTabChallenge;
  } catch (e) {
    console.log(e);
    return tiTabChallenge;
  }
};

export const getStackDemandTIMCQ = async () => {
  let stackDemandMCQ = [];
  let tiChallengeMCQ = [];
  try {
    const allChallenge = await getAllMCQChallenges();
    const body = {
      action: 'GET_STACK_DEMAND_MCQ_ID'
    };
    const token = localStorage.getItem('token');
    let header;

    if (token) {
      header = {
        'Content-Type': 'application/json',
        Authorization: token
      };
      const res = await axios.post(`${ApiConstant.BASE_URL}challenge/`, body, { headers: header });
      if (res.data.success && res.data.result) {
        const demandStackIdArray = res.data.result.in_stack_mcq ? res.data.result.in_stack_mcq.split(',') : [];
        const tiChallengeArray = res.data.result.ti_role_challenge ? res.data.result.ti_role_challenge.split(',') : [];
        if (allChallenge.data.success && allChallenge.data.result.length > 0) {
          stackDemandMCQ = allChallenge.data.result.filter(challenge => {
            const stackChallenge = demandStackIdArray.indexOf(challenge.challenge_id.toString()) !== -1;
            challenge.order = parseFloat(demandStackIdArray.indexOf(challenge.challenge_id.toString()));
            challenge.tags = challenge.tag_name;
            // Please make a note that `category_names` has been removed from the new MCQ List API /api/v1/challenge/mcq/
            challenge.tag_name = challenge.category_names;
            if (stackChallenge) return challenge;
          });
          tiChallengeMCQ = allChallenge.data.result.filter(challenge => {
            const tiChallenge = tiChallengeArray.indexOf(challenge.challenge_id.toString()) !== -1;
            challenge.tags = challenge.tag_name;
            // Please make a note that `category_names` has been removed from the new MCQ List API /api/v1/challenge/mcq/
            challenge.tag_name = challenge.category_names;
            if (tiChallenge) return challenge;
          });
          return { stackDemandMCQ: stackDemandMCQ.sort((a, b) => a.order - b.order), tiChallengeMCQ };
        }
      }
      return { stackDemandMCQ, tiChallengeMCQ };
    } else {
      return { stackDemandMCQ, tiChallengeMCQ };
    }
  } catch (e) {
    console.log(e);
    return { stackDemandMCQ, tiChallengeMCQ };
  }
};

export const convertTime = (time) => {
  const minuteToHour = 60;
  if (time < minuteToHour) {
    return `${time} min`;
  }
  if (time > minuteToHour) {
    const wholeHour = time / 60;
    const remHour = Math.floor(wholeHour);
    const minute = (wholeHour - remHour) * 60;
    const remMinute = Math.round(minute);
    if (remMinute > 0) {
      if (remHour > 1) {
        return `${remHour} hrs ${remMinute} min`;
      }
      return `${remHour} hr ${remMinute} min`;
    }
    return remHour > 1 ? `${remHour} hrs` : `${remHour} hr`;
  } else {
    const hour = time / minuteToHour;
    return hour > 1 ? `${hour} hrs` : `${hour} hr`;
  }
};

export const loadRecommendedJobs = async () => {
  return axios.post(`${ApiConstant.BASE_URL}job-apply/`, { action: "GET_USER_RECOMMENDED_JOBS" })
    .then((res) => {
      return res.data.jobs;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
}

export const applyToRecommendedJob = async (jobId, primarySource = "RECOMMENDED_JOB", jobCode) => {
  return axios.post(`${ApiConstant.BASE_URL}job-apply/`, { action: 'APPLY_TO_RECOMMENDED_JOBS', jobCode, jobId, primarySource })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
    });
}

export const submitAsNotInterested = async (jobId, primarySource = "RECOMMENDED_JOB", notInterestedReasonSystemName, notInterestedFeedback) => {
  console.log('submit not interested')
  return axios.post(`${ApiConstant.BASE_URL}submit-not-interested/`, { jobId, primarySource, notInterestedReasonSystemName, notInterestedFeedback })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
    });
}

export const loadFastrackFlows = async () => {
  return axios.get(`${ApiConstant.BASE_URL}fast-track-flows/`)
    .then((res) => {
      return res.data.flows;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
}

export const loadJobsApplied = async () => {
  try {
    const appliedJobs = await axios.get(`${ApiConstant.BASE_URL}jobs-applied`);
    if (appliedJobs && appliedJobs.data && appliedJobs.data.jobs) {
      const { jobs } = appliedJobs.data;
      return jobs;
    } else {
      return [];
    }
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const loadJobsV2 = async () => {
  return axios.post(`${ApiConstant.BASE_URL}jobs`)
    .then((res) => {
      const token = localStorage.getItem('token');
      const user = jwt.decode(token);
      const jobs = res.data.jobs;
      pushLog2DV2LogServer.info('JOB_APPLICATIONS', 'JOBS_FETCHED',
        {user_id: user.uid},
        {user_id: user.uid, timestamp: new Date(), jobs},
      )
      return { jobs };
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
};
